import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { withRouter } from 'react-router-dom';
import NavigationTabs from '../nav/NavigationTabs';
import { AlertJsMessage } from './../../helpers.js';

class Form extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			dataLoaded: false,
			editInstruction: null,
			isValidating: false,
			submitAction: 'create',
			isAudioDelete: false,
			formData: {
				description: '',
				catId: null,
				name: ''
			},
		};
	}
	componentDidMount() {
		this.props.fetch(this.props.user._id || localStorage.id, this.props.editId).then(() => {
			const { editId, instructions } = this.props;
			if (editId) {
				if (instructions[editId]) {
					const editInstruction = instructions[editId];
					const shortsUrl = editInstruction.shortsUrl
					let description = editInstruction.description;
					if(shortsUrl && shortsUrl !== '') {
						description = shortsUrl
					}
					this.setState({
						...this.state,
						dataLoaded: true,
						editInstruction: editInstruction,
						submitAction: 'edit',
						formData: {
							name: editInstruction.name,
							description: description,
							catId: editInstruction.catId
						},
					});
				}
			} else {
				this.setState({
					...this.state,
					submitAction: 'create',
					dataLoaded: true,
				});
			}
		});
	}

	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value,
			},
		});
	};
	handleOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};
	matchYoutubeUrl(url) {
		const p = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
		if(url.match(p)){
			return url.match(p)[1];
		}
		return false;
	};
	validateForm() {
		let formData = { ...this.state.formData };
		const lib_URL = '/library/instructions';
		const { addInstruction, edit, editId, history, user, onClose } = this.props;
		const required = ['name', 'description', 'catId'];
		for (var i = 0; i < required.length; i++) {
			if (!formData[required[i]]) {
				AlertJsMessage('Please enter all fields.');
				return;
			}
		}
		if(!this.matchYoutubeUrl(formData.description)) {
			AlertJsMessage('Please enter valid youtube link.');
			return;
		}
		let description = formData.description;
		let updatedFormData = {...formData };
		if(description.includes('shorts')) {
			const p = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
			updatedFormData.description = `https://youtu.be/${description.match(p)[1]}`
			updatedFormData.shortsUrl = description;
		} else {
			updatedFormData.shortsUrl = '';
		}
		if (this.state.submitAction === 'create') {
			addInstruction(updatedFormData, user.type).then(() => {
				const { formData } = this.state;
				this.setState({
					...this.state,
					formData: {
						...formData,
						catId: null,
						name: '',
						description: ''
					}
				})
			});
		} else {
			edit(editId, updatedFormData, user.type).then(() => {
				onClose && onClose();
				setTimeout(() => {
					window.location.reload();
				});
			});
		}
	}

	renderMenuOptions = option => (
		<MenuItem key={option._id} value={option._id}>
			{option.name}
		</MenuItem>
	);

	render() {
		const { formData, dataLoaded } = this.state;
		const { cats } = this.props;
		return (
			<div>
				{this.props.hideNavigationTabs ? null : (
					<NavigationTabs
						title="Build"
						subtitle="YouTube"
						set="build"
						activeRoute="/build/instruction"
					/>
				)}
				{dataLoaded && (
					<React.Fragment>
						<TextField
							label="Title"
							value={formData.name}
							onChange={this.handleChange('name')}
							margin="dense"
							variant="outlined"
							inputProps={{ maxLength: 60 }}
						/>
						<TextField
							select
							label="Category"
							value={formData.catId}
							onChange={this.handleChange('catId')}
							margin="dense"
							variant="outlined"
						>
							{Object.values(cats).map(this.renderMenuOptions)}
						</TextField>
						<TextField
							label="YouTube Link"
							value={formData.description}
							onChange={this.handleChange('description')}
							margin="dense"
							variant="outlined"
							inputProps={{ maxLength: 250 }}
						/>
						<Button
							disabled={this.state.isValidating}
							onClick={() => this.validateForm()}
							variant="contained"
							color="primary"
						>
							{this.state.editInstruction ? 'Update YouTube' : 'Add YouTube'}
						</Button>
					</React.Fragment>
				)}
			</div>
		);
	}
}
export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/components/instructions/Form.js